import { defineMessages } from "react-intl"

export const modelInformationMessages = defineMessages({
	countryVehicleSpecification: {
		defaultMessage: "Country Vehicle Specification",
		id: "vehicleDetails.overview.modelInformation.list.countryVehicleSpecification",
	},
	derivative: {
		defaultMessage: "Derivative",
		id: "vehicle.modelInformation.derivative",
	},
	driveTrain: {
		defaultMessage: "Drivetrain",
		id: "vehicle.modelInformation.driveTrain",
	},
	engineType: {
		defaultMessage: "Engine Type",
		id: "vehicle.modelInformation.engineType",
	},
	modelGeneration: {
		defaultMessage: "Model Generation",
		id: "vehicle.modelInformation.modelGeneration",
	},
	modelSeries: {
		defaultMessage: "Model Series",
		id: "vehicle.modelInformation.modelSeries",
	},
	modelYear: {
		defaultMessage: "Model Year",
		id: "vehicle.modelInformation.modelYear",
	},
	orderType: {
		defaultMessage: "Order Type",
		id: "vehicle.modelInformation.orderType",
	},
	transmission: {
		defaultMessage: "Transmission",
		id: "vehicle.modelInformation.transmission",
	},
})
